import { observer } from "mobx-react";
import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { BetSlipStatusAbrv } from "@utils";

export default observer(function Gain() {
	const { t } = useTranslation("mybets");
	const bet = useContext(MyBetsBetContext);

	if (bet.betStatus?.abrv !== BetSlipStatusAbrv.WON) {
		return null;
	}

	if (bet.gain == null || bet.gain == 0) {
		return null;
	}
	return (
		<tr className="table--bets__tr">
			<td className="table--bets__dd">{t("ITEM.ADDITIONAL_GAIN")}</td>
			<td className="table--bets__dd u-color--offer--win">
				{bet.displayGain}
			</td>
		</tr>
	);
});
